<template>
    <div>
        <!-- Intervenants -->
        <h1 class="label">Financeurs</h1>
        <div class="level">
            <b-button class="is-primary" @click="isAddModalActive = true">
                Ajouter un financeur
            </b-button>
            <b-button class="is-primary" @click="isInfoModalActive = true">
                Information sur les calculs
            </b-button>
            <b-button class="is-warning" @click="deleteAllFI">
                Supprimer tous les financeurs
            </b-button>

        </div>
        <b-table :data="fi">
            <template>
                <b-table-column field="fi" label="Financeur" width="300" sortable
                                v-slot="props">
                    {{ props.row.fi }}
                </b-table-column>

                <b-table-column field="cost" label="Coût pris en charge" sortable v-slot="props">

                    <b-tooltip position="is-top" type="is-dark" multilined>
                        {{
                            ctma ?
                                totalCostProject * (props.row.percent / 100)
                                :
                                props.row.pclock ?
                                    (ProjectSalarieCost * (props.row.percent / 100) * (props.row.tauxfg / 100))
                                    + (totalCostProjectSansFG * (props.row.percent / 100))
                                    :
                                    props.row.cost
                        }} €
                        <b-icon
                            v-if="!props.row.pclock"
                            icon="lock"
                            size="is-small">
                        </b-icon>
                        <!-- Detail on hover -->
                        <template v-slot:content>
                            {{
                                ctma ?
                                    ` 💵 ${totalCostProject * (props.row.percent / 100)} €`
                                    :
                                    props.row.pclock ?
                                        ` 💵 ${ roundTwoDigits(totalCostProjectSansFG * (props.row.percent / 100), 4)} € + 🪣 ${roundTwoDigits(ProjectSalarieCost * (props.row.percent / 100) * (props.row.tauxfg / 100), 4)} €`
                                        :
                                        ` 💵 ${roundTwoDigits(props.row.cost - (props.row.tauxfg/100 * props.row.percent/100 * ProjectSalarieCost), 4) } € + 🪣 ${roundTwoDigits(props.row.tauxfg/100 * props.row.percent/100 * ProjectSalarieCost, 4) } €`
                            }}
                        </template>
                    </b-tooltip>

                </b-table-column>

                <b-table-column field="percent" label="% sur le coût sans FG" sortable v-slot="props">
                    {{
                        props.row.pclock ?
                            props.row.percent :
                            ctma ?
                                roundTwoDigits((props.row.cost * 100 / totalCostProjectSansFG), 6)
                                :
                                roundTwoDigits((props.row.cost / (props.row.tauxfg/100 * ProjectSalarieCost + totalCostProjectSansFG))*100, 6)
                    }} %
                    <b-icon
                        v-if="props.row.pclock"
                        icon="lock"
                        size="is-small">
                    </b-icon>
                </b-table-column>

                <b-table-column field="percenttotal" label="% sur le total" sortable v-slot="props">
                    {{
                        ctma ?
                            roundTwoDigits((totalCostProject * (props.row.percent / 100)) / totalCostProject * 100, 2)
                            :
                            props.row.pclock ?
                                roundTwoDigits(((ProjectSalarieCost * (props.row.percent / 100) * (props.row.tauxfg / 100))
                                + (totalCostProjectSansFG * (props.row.percent / 100))) / totalCostProject * 100, 2)
                                :
                                roundTwoDigits(props.row.cost / totalCostProject * 100, 2)
                    }} %
                </b-table-column>

                <b-table-column field="percentfg" label="% frais généraux" sortable v-slot="props">
                    {{ props.row.tauxfg }} %
                </b-table-column>

                <b-table-column field="comment" label="Commentaire" v-slot="props">
                    {{ props.row.comment || '_____________' }}
                </b-table-column>

                <b-table-column label="Editer" v-slot="props">
                    <b-button
                        type="is-warning"
                        icon-left="pen"
                        @click="openEditModal(props.row)"
                    ></b-button>
                </b-table-column>

                <b-table-column label="Supprimer" v-slot="props">
                    <b-button
                        type="is-danger"
                        icon-left="trash"
                        @click="deleteFI(props.row)">
                    </b-button>
                </b-table-column>

                <!-- Footer -->
                <template slot="footer">
                    <th style="width:40px">
                        <div class="th-wrap is-numeric"> Nb. de financeurs : {{ fi.length }}</div>
                    </th>
                    <th>
                        <div class="th-wrap"> Total : {{ totalCost }} €</div>
                    </th>
                    <th>
                        <!-- TODO couleur si > 100 % -->
                        <div class="th-wrap"
                             :style="{color: parseInt(totalPercent) === 100 ? 'green' : 'red'}">
                            Total : {{ totalPercent }} %
                            <br>
                            (Manque {{ 100 - totalPercent }} %)
                        </div>
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                </template>

            </template>
        </b-table>

        <b-modal :active.sync="isEditModalActive" has-modal-card>
            <FINEditModal
                :uuid=this.selectedLine.uuid
                :fi=this.selectedLine.fi
                :cost=this.selectedLine.cost
                :comment=this.selectedLine.comment
                :pclock=this.selectedLine.pclock
                :percent=this.selectedLine.percent
                :tauxfg=this.selectedLine.tauxfg
                :totalCostProjectSansFG="totalCostProjectSansFG"
                :totalCostProject="totalCostProject"
                :ctma="ctma"
                :fg="fg"
                :ProjectSalarieCost="ProjectSalarieCost"
                @edit-fi="onEditFI"
            ></FINEditModal>
        </b-modal>

        <b-modal :active.sync="isAddModalActive" has-modal-card>
            <FINAddModal
                @add-fi="onAddFI"
                :refFI="refFI"
                :totalCostProjectSansFG="totalCostProjectSansFG"
                :totalCostProject="totalCostProject"
                :ctma="ctma"
                :fg="fg"
                :ProjectSalarieCost="ProjectSalarieCost"
            >
            </FINAddModal>
        </b-modal>

        <b-modal
            :active.sync="isInfoModalActive"
            full-screen
            can-cancel
        >
            <CalculInfoModal/>
        </b-modal>
    </div>

</template>

<script>
import FINEditModal from "@/components/FINEditModal";
import FINAddModal from "@/components/FINAddModal";
import CalculInfoModal from "@/components/CalculInfoModal";
import {v4 as uuidv4} from 'uuid';

export default {
    name: "Financeurs",
    props: {
        totalCostProjectSansFG: {
            type: Number,
            required: true
        },
        totalCostProject: {
            type: Number,
            required: true
        },
        ProjectSalarieCost: {
            type: Number,
            required: true
        },
        ctma: {
            type: Boolean,
            required: true
        },
        fg: {
            type: Boolean,
            required: true
        },
    },
    components: {FINEditModal, FINAddModal, CalculInfoModal},
    watch: {
        totalCostProjectSansFG(newValue, oldValue) {
            // If totalCost is updated
            console.log(`Updating from ${oldValue} to ${newValue}`);
            // Calculation on the fly for the new cost
            this.fi.forEach(f => {
                if (f.pclock === true && parseFloat(f.percent)) {
                    f.cost = this.totalCostProjectSansFG * (parseFloat(f.percent) / 100)
                }
            })
            this.saveLocalStorageFI();
        }
    },
    mounted() {
        if (localStorage.getItem("fi")) {
            this.fi = JSON.parse(localStorage.getItem("fi"));
        } else {
            this.fi = [];
        }
        // Load ref
        this.$axios.get('ref/financeurs')
        .then(function (response) {
            this.refFI = response.data.financeurs;
        }.bind(this))
        .catch(error => console.log(error));
    },
    computed: {
        totalCost() {
            let sum = 0;
            this.fi.forEach(fi => {
                // console.log(fi)
                sum +=
                    this.ctma ?
                        this.totalCostProject * (fi.percent / 100)
                        :
                        fi.pclock ?
                            (this.ProjectSalarieCost * (fi.percent / 100) * (fi.tauxfg / 100))
                            + (this.totalCostProjectSansFG * (fi.percent / 100))
                            :
                            parseFloat(fi.cost)
            })
            this.$emit('updateProjectFICost', sum, this.fi); // TODO
            return sum
        },
        totalPercent() {
            let percent = 0;
            this.fi.forEach(f => {
                percent +=
                    f.pclock ?
                        f.percent :
                        this.ctma ?
                            (f.cost * 100 / this.totalCostProjectSansFG)
                            :
                            (f.cost / (f.tauxfg/100 * this.ProjectSalarieCost + this.totalCostProjectSansFG))*100
            })
            return this.roundTwoDigits(percent, 6);
        },
    },
    methods: {
        openEditModal(line) {
            this.selectedLine = line;
            this.isEditModalActive = true;
        },
        onAddFI(item) {
            // Add the item to the array
            this.fi.push({
                uuid: uuidv4(),
                fi: item.fi,
                cost: item.cost,
                comment: item.comment,
                pclock: item.pclock,
                percent: parseFloat(item.percent),
                tauxfg: parseFloat(item.tauxfg)
            });
            // save the updated array in localstorage
            this.saveLocalStorageFI();
            this.isAddModalActive = false;
        },
        onEditFI(item) {
            console.log(item);
            const fii = this.findFI(item);
            // Apply the updated values
            fii.cost = parseFloat(item.cost);
            fii.comment = item.comment;
            fii.pclock = item.pclock;
            fii.percent = parseFloat(item.percent);
            fii.tauxfg = parseFloat(item.tauxfg);
            // save the updated array in localstorage
            this.saveLocalStorageFI();
            // close the modal
            this.isEditModalActive = false;
        },
        deleteFI(item) {
            this.$buefy.dialog.confirm({
                title: `Supprimer la ligne`,
                confirmText: "Supprimer la ligne",
                type: "is-danger",
                hasIcon: true,
                message: `Etes-vous sûr de supprimer cette ligne ? Cette action ne pourra être annulée.`,
                onConfirm: () => {
                    // find in the array and remove
                    const index = this.fi.indexOf(item);
                    this.fi.splice(index, 1);
                    // save the updated array in localstorage
                    this.saveLocalStorageFI();
                }
            });
        },
        deleteAllFI() {
            this.$buefy.dialog.confirm({
                title: `Supprimer tous les salariés`,
                confirmText: "Oui, je confirme",
                type: "is-danger",
                hasIcon: true,
                message: `Etes-vous sûr de vouloir supprimer l'ensemble des salariés ? Cette action ne pourra pas être annulée`,
                onConfirm: () => {
                    this.fi = [];
                    // save the updated array in localstorage
                    this.saveLocalStorageFI();
                }
            });
        },
        findFI(item) {
            return this.fi.find(fii => fii.uuid === item.uuid);
        },
        saveLocalStorageFI() {
            localStorage.setItem("fi", JSON.stringify(this.fi));
            this.fi = JSON.parse(localStorage.getItem("fi"));
        }
    },
    data() {
        return {
            fi: [],
            refFI: [],
            isEditModalActive: false,
            selectedLine: {},
            isAddModalActive: false,
            isInfoModalActive: false,
        }
    },
}
</script>

<style scoped>

</style>
